// frontend/src/components/games/AchievementToastHost.tsx

import { useEffect, useState } from 'react';
import { AchievementDefinition } from '../../config/achievements';
import { subscribeAchievementUnlocks } from '../../services/games/achievementBus';
import '../../styles/games-achievements.css';

interface ToastItem extends AchievementDefinition {
  toastId: number;
}

let toastCounter = 0;
const TOAST_DURATION_MS = 5000;

export function AchievementToastHost() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    return subscribeAchievementUnlocks((achievements) => {
      const items: ToastItem[] = achievements.map((a) => ({ ...a, toastId: ++toastCounter }));
      setToasts((prev) => [...prev, ...items]);
      items.forEach((item) => {
        setTimeout(() => {
          setToasts((prev) => prev.filter((t) => t.toastId !== item.toastId));
        }, TOAST_DURATION_MS);
      });
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="achievement-toast-stack">
      {toasts.map((toast) => (
        <div key={toast.toastId} className="achievement-toast">
          <div className="achievement-toast-icon">{toast.icon}</div>
          <div className="achievement-toast-body">
            <div className="achievement-toast-label">🏆 Başarım Kazanıldı!</div>
            <div className="achievement-toast-title">{toast.title}</div>
            <div className="achievement-toast-desc">{toast.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
